import React, { ReactElement } from 'react';

import { Col, Divider, Form, Layout, Row, Spin, TypographyText } from '@components/atoms';
import InputField from '@components/molecules/InputField';
import { Page } from '@constants/enum';
import {
  PERSONAL_TERM_AGREEMENT_COMMENT,
  SERVICE_TERM_AGREEMENT_COMMENT,
  SURVET_START_COMMENT,
  TERM_GUIDE_COMMENT,
} from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';
import _ from 'lodash';

function Term({
  data,
  loading = false,
  setPageIndex,
}: {
  data: any;
  loading: boolean;
  setPageIndex: any;
}): ReactElement {
  const { form, formData, formFieldsError, validationChecker, setFormData } = useReduxForm('survey');
  const { patient, clinic } = data;

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {loading || _.isEmpty(data) ? (
        <Spin spinning={loading}>
          <></>
        </Spin>
      ) : (
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Row
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <Row>
              <Col style={{ width: '143px', height: '110px' }} yzTypeCol="center">
                <img alt="termImg" src={`${process.env.PUBLIC_URL}/img/term4x.webp`} width="143px" />
              </Col>
            </Row>
            <Divider margin={5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
            <Row>
              <Col yzTypeCol="center">
                <TypographyText yzTypeTypographyText="title">{SURVET_START_COMMENT}</TypographyText>
              </Col>
            </Row>
            <Divider margin={7} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
            <Row>
              <Col style={{ whiteSpace: 'pre-wrap', wordBreak: 'keep-all' }} yzTypeCol="survey-guide">
                <TypographyText yzTypeTypographyText="basic">
                  {`${patient?.patientName} 고객님, 안녕하세요.
${clinic?.trim()}입니다.
${TERM_GUIDE_COMMENT}`}
                </TypographyText>
              </Col>
            </Row>
          </Row>
          <Row
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                position: 'absolute',
                borderTop: '1px solid #f5f5f5',
                width: 'calc(100% + 48px)',
                left: '-24px',
              }}
            />
            <Form form={form} labelAlign="left">
              <InputField
                borderTop={false}
                componentArray={[
                  {
                    type: 'customRender',
                    dataIndex: 'serviceTermAgreement',
                    customRender: () => (
                      <Row yzTypeRow="term-bottom-1">
                        <Col>
                          <Col
                            onClick={() =>
                              setFormData('serviceTermAgreement', !(formData?.serviceTermAgreement ?? false))
                            }
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              columnGap: '8px',
                            }}
                          >
                            <Col
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {formData?.serviceTermAgreement ?? false ? (
                                <img
                                  alt="checked"
                                  src={`${process.env.PUBLIC_URL}/img/checked-blue.webp`}
                                  style={{ width: '16px', cursor: 'pointer' }}
                                />
                              ) : (
                                <img
                                  alt="unchecked"
                                  src={`${process.env.PUBLIC_URL}/img/unchecked-icon.webp`}
                                  style={{ width: '16px', cursor: 'pointer' }}
                                />
                              )}
                            </Col>
                            <Col
                              style={{
                                cursor: 'pointer',
                              }}
                            >
                              <TypographyText
                                fontSize="12px"
                                fontWeight={700}
                                letterSpacing="0.005em"
                                lineHeight="12px"
                              >
                                {SERVICE_TERM_AGREEMENT_COMMENT}
                              </TypographyText>
                            </Col>
                          </Col>
                        </Col>
                        <Col
                          onClick={() => {
                            setPageIndex(Page.ServiceTerm);
                          }}
                        >
                          <TypographyText
                            color="#afafaf"
                            fontSize="10px"
                            fontWeight={700}
                            letterSpacing="0.005em"
                            lineHeight="12px"
                            textDecoration="underline"
                          >
                            자세히보기
                          </TypographyText>
                        </Col>
                      </Row>
                    ),
                  },
                ]}
                formFieldsError={formFieldsError}
                style={{ height: '22px' }}
                validation={validationChecker}
              />
            </Form>
            <Form form={form} labelAlign="left">
              <InputField
                borderTop={false}
                componentArray={[
                  {
                    type: 'customRender',
                    dataIndex: 'personalTermAgreement',
                    customRender: () => (
                      <Row yzTypeRow="term-bottom-2">
                        <Col
                          onClick={() =>
                            setFormData('personalTermAgreement', !(formData?.personalTermAgreement ?? false))
                          }
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '8px',
                          }}
                        >
                          <Col
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {formData?.personalTermAgreement ?? false ? (
                              <img
                                alt="checked"
                                src={`${process.env.PUBLIC_URL}/img/checked-blue.webp`}
                                style={{ width: '16px', cursor: 'pointer' }}
                              />
                            ) : (
                              <img
                                alt="unchecked"
                                src={`${process.env.PUBLIC_URL}/img/unchecked-icon.webp`}
                                style={{ width: '16px', cursor: 'pointer' }}
                              />
                            )}
                          </Col>
                          <Col
                            style={{
                              cursor: 'pointer',
                            }}
                          >
                            <TypographyText
                              fontSize="12px"
                              fontWeight={700}
                              letterSpacing="0.005em"
                              lineHeight="12px"
                            >
                              {PERSONAL_TERM_AGREEMENT_COMMENT}
                            </TypographyText>
                          </Col>
                        </Col>
                        <Col
                          onClick={() => {
                            setPageIndex(Page.PersonalInfoTerm);
                          }}
                        >
                          <TypographyText
                            color="#afafaf"
                            fontSize="10px"
                            fontWeight={700}
                            letterSpacing="0.005em"
                            lineHeight="12px"
                            textDecoration="underline"
                          >
                            자세히보기
                          </TypographyText>
                        </Col>
                      </Row>
                    ),
                  },
                ]}
                formFieldsError={formFieldsError}
                style={{ height: 'fit-content' }}
                validation={validationChecker}
              />
            </Form>
          </Row>
        </div>
      )}
    </div>
  );
}

export default Term;
